<template>
  <div>
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="show">
          <TableFilters
            :filters="['search', 'dateRange', 'toShop', 'fromShop']"
            v-model="filter"
            :columns="columns"
            :msgs="'Reference No'"
          ></TableFilters>
        </v-card>
      </v-expand-transition>
      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <ValidationObserver ref="observer">
            <form>
              <v-row v-if="messages.length != 0">
                <v-col>
                  <v-card>
                    <v-card-text>
                      <v-row>
                        <template>
                          <v-alert
                            v-for="msg in messages"
                            :key="msg"
                            class="messages"
                            outlined
                            type="error"
                            >{{ msg }}</v-alert
                          >
                        </template>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-card-text class="pa-0">
                  <v-data-table
                    :items-per-page="paginationOptions.perPage"
                    :headers="headers"
                    @click:row="
                      $router.push(`stock-transfer/shop-to-shop/${$event.id}`)
                    "
                    class="row-pointer"
                    :items="TransferList"
                    hide-default-footer
                    style="font-family: 'Source Sans Pro', sans-serif"
                  >
                    <template v-slot:no-data>
                      <div class="mt-16 container justify-center item-center">
                        <noData name="stock transfer" />
                      </div>
                    </template>
                    <template v-slot:item.reference_number="{ item }">
                      <CopyTableCell
                        :text="item.reference_number"
                      ></CopyTableCell>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :x-small="true"
                        label
                        text-color="white"
                        :color="GetChequeStatusColor('Completed')"
                        dark
                        >Completed</v-chip
                      ></template
                    >

                    <template v-slot:item.date="{ item }">{{
                      item.date | formatDate
                    }}</template>
                    <template v-slot:item.fromShop="{ item }">
                      {{
                        ShopView == 'sortform'
                          ? item.fromShop.name
                          : item.fromShop.sortform
                      }}
                    </template>
                    <template v-slot:item.toShops="{ item }">
                      {{
                        ShopView == 'sortform'
                          ? item.toShop.name
                          : item.toShop.sortform
                      }}
                    </template>

                    <!-- Actions -->
                    <template v-slot:item.actions="{ item }">
                      <list-menu
                        feature="stock-transfer/shop-to-shop"
                        :item="item"
                        viewPermission="Transfer Show"
                        @refreshList="refreshData"
                      ></list-menu>
                      <!-- <list-menu
                        v-if="item.status != 'Pending'"
                        feature="stock-transfer"
                        :item="item"
                        viewPermission="Transfer Show"
                        @refreshList="refreshData"
                      ></list-menu> -->
                    </template>
                    <template v-slot:footer="{}">
                      <paginationComponent
                        @paginationOptions="setPaginationOptions"
                        :url="'shop-transfers'"
                        @getPageNumber="setPagenumber"
                        :filterAction="true"
                        @response="receiveTransferData"
                        :filter="filter"
                      />
                      <!-- :url="'purchases-orders'" -->
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-row>
            </form>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { PurchaseOrder } from '../../../models/EntityModels/PurchaseOrder';
import { required, email, max, numeric } from 'vee-validate/dist/rules';
import noData from '../../../components/shared/noItem';
import TableFilters from '@/components/base/TableFilters';
import { mapState } from 'vuex';

// Mixins
import Suppliers from '@/mixins/Suppliers';
import _ from 'lodash';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { Product } from '../../../models/Product';

import { ProductViewModel } from '../../../models/View Models/ProductViewModel';
import paginationComponent from '../../shared/components/pagination.vue';
import { mapGetters } from 'vuex';
import { has } from 'lodash';

import confirmation from '../../shared/components/confirmation';

extend('numeric', {
  ...numeric,
  message: 'input must be numeric',
});
export default {
  data: () => ({
    show: true,
    paginationOptions: {},
    messages: [],

    columns: [
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '17%',
      },
      {
        text: 'Reference No',
        value: 'reference_number',
        show: true,
        disabled: false,
        align: 'left',
        width: '17%',
      },

      {
        text: 'From Shop',
        value: 'fromShop.name',
        show: true,
        disabled: false,
        align: 'left',
        width: '17%',
      },
      {
        text: 'To Shop',
        value: 'toShop.name',
        show: true,
        disabled: false,
        align: 'left',
        width: '17%',
      },

      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
        width: '17%',
      },
      {
        text: 'Actions',
        value: 'actions',
        show: true,
        disabled: true,
        align: 'center',
        width: '15%',
      },
    ],
    TransferList: [],
    filter: {},
    menu: false,
  }),
  components: {
    ValidationProvider,
    ValidationObserver,
    paginationComponent,
    noData,
    TableFilters,
  },
  computed: {
    ...mapGetters(['getInvoiceStatusOptions']),
    ...mapState(['ShopView']),
    ...mapState(['ProductView']),

    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    refreshData() {},
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    receiveTransferData(data) {
      this.TransferList = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },

    GetChequeStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        default:
          break;
      }
    },
  },
  created() {},
  watch: {},
  filters: {
    hasName: function (value) {
      if (has(value, 'name')) return value.name;
      else return '-';
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
.st-100 {
  font-weight: bold;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}
.min-button::before {
  display: none;
}
</style>
